export enum VideoStatus {
    Processing,
    Available,
    Archiving,
    Archived,
    Restoring
}
